export function yearsList(qtdAnos : number = 5) : number []  {
    let anoAtual = new Date().getFullYear();
    let listaAnos : number []  = [];
    for(let i = 0; i < qtdAnos ; i++ ) {
      listaAnos.push(anoAtual);
      --anoAtual;
    }
    return listaAnos
}

export function downloadCsv(csvContent : string,name: string) {
   // Cria um elemento de link invisível
   const hiddenElement = document.createElement('a');
   hiddenElement.setAttribute('href', encodeURI(csvContent));
   hiddenElement.setAttribute('download', name+'.csv');

   // Adiciona o link ao corpo do documento
   document.body.appendChild(hiddenElement);

   // Clica no link para iniciar o download
   hiddenElement.click();

   // Remove o link do documento
   document.body.removeChild(hiddenElement);
}